import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

/**
 * ProtectedRoute
 *   role="admin"  → redirects to /admin/login when not signed in as admin
 *   role="client" → redirects to /client/login when not signed in as client
 * If no role prop, accepts any authenticated user (defaults to admin fallback).
 */
export const ProtectedRoute = ({ children, role = "admin" }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] text-[var(--ink-50)]">
        <Loader2 className="w-6 h-6 animate-spin mr-3" />
        <span className="text-xs uppercase tracking-[0.28em]">Authorising…</span>
      </div>
    );
  }

  const loginPath = role === "client" ? "/client/login" : "/admin/login";

  if (user === null) {
    return <Navigate to={loginPath} state={{ from: location.pathname }} replace />;
  }

  if (role && user.role !== role) {
    // Signed in but wrong role — send them to their own dashboard
    const home = user.role === "client" ? "/client" : "/admin";
    return <Navigate to={home} replace />;
  }

  return children;
};

export default ProtectedRoute;
